import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TextField, Button, Container, Typography, Alert, CircularProgress, InputAdornment } from '@mui/material';
import axiosInstance from '../services/api';

const LoginPage = () => {
    const [credentials, setCredentials] = useState({ username: '', password: '' });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    
    
    //console logs
    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        //console.log("SAT Login attempt to:", axiosInstance.defaults.baseURL + '/token/');
        //2nd July, 2026 Commented above line
        try {
            const response = await axiosInstance.post('/token/', credentials);

            //Debug
            /*
            console.log('[Login Success]', {
                access_token: response.data.access?.slice(0, 10) + '...',
                refresh_token: response.data.refresh?.slice(0, 10) + '...',
                role: response.data.role
            });*/ //2nd July, 2026 commented above debug logs
            
            // Store tokens and user data
            localStorage.setItem('access_token', response.data.access);
            localStorage.setItem('refresh_token', response.data.refresh);
            localStorage.setItem('role', response.data.role);
            //localStorage.setItem('role', response.data.system_role);
            // MUST use EXACTLY this line after successful login
            //Commented below line on 2nd July, 2026.
            //console.log('[Login] Successful, redirecting...');
            //const role = response.data.role.toLowerCase(); // Changed from system_role
            //localStorage.setItem('role', role);
            navigate('/dashboard');
            //Commented below line on 2nd July, 2026.
            //console.log('Login Response:', response.data);
            
        } catch (error) {
            // ... keep your existing error handling
            console.error('[Login Failed]', {
                status: error.response?.status,
                data: error.response?.data,
                config: error.config
              });
              // ... error handling
                // Improved error handling
                let errorMessage = 'Login failed';
                if (error.response) {
                    switch (error.response.status) {
                        case 401: errorMessage = 'Invalid credentials'; break;
                        case 403: errorMessage = 'Account inactive'; break;
                        case 404: errorMessage = 'Service unavailable'; break;
                        default: errorMessage = `Server error (${error.response.status})`;
                    }
                    
                } else if (error.request) {
                    //Commented below line on 2nd July, 2026.
                    //console.error("SAT Request details:", error.request);
                    errorMessage = 'Network error - check connection';
                }
                setError(errorMessage);
        } finally {
            setLoading(false);
        }
    };


    return (
        <Container maxWidth="xs" sx={{ mt: 8 }}>
            <Typography variant="h4" gutterBottom align="center">
                MedicERP Login
            </Typography>
            
            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

            <form onSubmit={handleLogin}>
                <TextField
                    label="Username"
                    fullWidth
                    margin="normal"
                    required
                    value={credentials.username}
                    onChange={(e) => setCredentials({...credentials, username: e.target.value})}
                    InputProps={{
                        readOnly: loading,
                    }}
                />
                <TextField
                    label="Password"
                    type="password"
                    fullWidth
                    margin="normal"
                    required
                    value={credentials.password}
                    onChange={(e) => setCredentials({...credentials, password: e.target.value})}
                    InputProps={{
                        readOnly: loading,
                        endAdornment: loading && (
                            <InputAdornment position="end">
                                <CircularProgress size={20} />
                            </InputAdornment>
                        ),
                    }}
                />
                
                <Button 
                    type="submit" 
                    variant="contained" 
                    fullWidth 
                    sx={{ mt: 2, mb: 2 }}
                    disabled={loading}
                >
                    {loading ? <CircularProgress size={24} /> : 'Sign In'}
                </Button>
                {/* Add this below the login button */}
                <Typography variant="body2" sx={{ mt: 2 }}>
                    Don't have an account? 
                    <Button 
                        onClick={() => navigate('/register')}
                        sx={{ textTransform: 'none' }}
                    >
                        Create Account
                    </Button>
                </Typography>
                <Typography variant="body2" sx={{ mt: 2 }}>
                    Need help? Contact support@medicerp.com
                </Typography>

            </form>
        </Container>
    );
};

export default LoginPage;